import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=047465f2&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047465f2')) {
      api.createRecord('047465f2', component.options)
    } else {
      api.rerender('047465f2', component.options)
    }
    module.hot.accept("./GeneralInfo.vue?vue&type=template&id=047465f2&functional=true", function () {
      api.rerender('047465f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referralValidity/components/tabs/GeneralInfo.vue"
export default component.exports